import { render, staticRenderFns } from "./AdministrationSettingsSwitch.vue?vue&type=template&id=ae23ff08&"
import script from "./AdministrationSettingsSwitch.vue?vue&type=script&lang=js&"
export * from "./AdministrationSettingsSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports